import {
  GLOBAL_SEARCH_ACCENT_TEXT_CLASS,
  GLOBAL_SEARCH_SURFACE_CLASS,
  buildGlobalSearchFilterSummaryText,
} from './constants.js';

/**
 * @param {object} props
 * @param {Array<{ id: string, label: string }>} [props.activeFilters]
 * @param {Record<string, string>} [props.labels]
 * @param {() => void} [props.onClearFilters]
 * @param {() => void} [props.onSearchAll]
 */
const TopbarGlobalSearchFilterSummary = ({
  activeFilters = [],
  labels = {},
  onClearFilters,
  onSearchAll,
}) => {
  if (activeFilters.length === 0) return null;

  const summaryText = buildGlobalSearchFilterSummaryText(activeFilters);
  if (!summaryText) return null;
  const showingResultsFor = labels.showingResultsFor ?? 'Showing results for';
  const clearFiltersLabel = labels.clearFilters ?? 'Clear filters';
  const searchAllLabel = labels.searchAll ?? 'Search All';

  return (
    <div
      className={[
        'flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-[#BABABA]/60 px-4 py-3 text-sm leading-5 dark:border-white/10',
        GLOBAL_SEARCH_SURFACE_CLASS,
      ].join(' ')}
    >
      <p className="min-w-0 flex-1 text-[#5C5C5C] dark:text-gray-400">
        {showingResultsFor}{' '}
        <span className="font-medium text-[#2A2A2A] dark:text-gray-100">{summaryText}</span>
      </p>
      <div className="flex shrink-0 items-center gap-3">
        {onClearFilters ? (
          <button
            type="button"
            onClick={onClearFilters}
            className={['text-sm font-medium leading-5', GLOBAL_SEARCH_ACCENT_TEXT_CLASS].join(' ')}
          >
            {clearFiltersLabel}
          </button>
        ) : null}
        {onSearchAll ? (
          <button
            type="button"
            onClick={onSearchAll}
            className={['text-sm font-medium leading-5', GLOBAL_SEARCH_ACCENT_TEXT_CLASS].join(' ')}
          >
            {searchAllLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default TopbarGlobalSearchFilterSummary;
